module.exports = "/img/rapbeat_wizdome_logo.png?632bf6179c734af1903cd5b69cf19367";